import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import swal from 'sweetalert'
import {
  get_project,
  archive_feed,
  publish_feed,
  update_xml,
  unpublish_feed,
  clone_feed,
} from '../actions/'
import Pagination from './Pagination'
import Clipboard from 'react-clipboard.js';

const mapStateToProps = (state) => {
  return {
    feed: state.feed.feed
  }
}

const mapDispatchToProps = dispatch => {
    return {
      getProject: (id, page) => dispatch ( get_project(id, page) ),
      archiveFeed: (feed_id, page) => dispatch ( archive_feed(feed_id, page) ),
      publishFeed: (id, page) => dispatch ( publish_feed(id, page) ),
      updateXML: (id, page) => dispatch ( update_xml(id, page) ),
      unpublishFeed: (id, page) => dispatch ( unpublish_feed(id, page) ),
      cloneFeed: (id, page, name) => dispatch( clone_feed(id, page, name) ),
    }
}

class ConnectedProjectOptimizations extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  archiveFeed(feed_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.feed.pagination
    this.props.archiveFeed(feed_id, page)
  }

  cloneFeed(feed_id) {
    const {page} = this.props.feed.pagination
    swal({
      text: "Name for cloned feed instance",
      content: "input",
      buttons: {
        confirm: {
          text: "Clone",
          value: true,
          visible: true,
          className: "btn red darken-1 waves-effect waves-light",
          closeModal: true
        }
      }
    }).then(name => {
      if ( name && name.length > 0) {
        this.props.cloneFeed(feed_id, page, name)
      }
    })
  }

  fetchProject = (i) => {
    const feed_id = this.props.feed.id
    this.props.getProject(feed_id, i)
  }

	render() {
		const { pagination, optimizations} = this.props;

		const { publishFeed, unpublishFeed, updateXML } = this.props;

    const feedActive = this.props.feed.active

		return (
			<React.Fragment>
				<table className="bordered striped highlight responsive-table project-list">
					<thead>
						<tr>
							<th>Feed Instance Name</th>
							<th>Date Created</th>
							{
                // <th>User</th>
              }
							<th>Details</th>
							<th>Status</th>
              { feedActive ? <th>Actions</th> : '' }
						</tr>
					</thead>
					<tbody>
						{optimizations.map(function(optimization){
							const {id, name, created_at, entries, new_entries, removed, active, xml_url, syncstatus, xml_pending, xml_updating, lengthwarning } = optimization;
              const current = this.state.clickedId
              const disabled = ( xml_pending === true || entries === 0 )
              let class1, class2, clip;
              //test = xml_url;

              let syncIcon, syncIconTitle;
              let syncButton = '';
              if ( typeof(syncstatus) !== "undefined" && syncstatus.match(/^synced/i)) {
                syncIconTitle = "XML is up to date"
                syncIcon = <i className="material-icons c-light-green" title={syncIconTitle}>check</i>;
              } else if (typeof(syncstatus) !== "undefined" &&  syncstatus.match(/^outofsync/) ) {
                if ( xml_updating ) {
                  const btnText = (xml_pending) ? "...publishing..." : "...updating..."
                  syncIconTitle = "XML is currently updating"
                  syncButton = (
                    <button className="btn orange darken-1 waves-effect waves-light"
                            disabled="disabled">{ btnText }</button>
                  )
                } else {
                  syncIconTitle = "XML is out of date"
                  syncButton = (
                    <button className="btn orange darken-1 waves-effect waves-light"
                    onClick={
                      () => {
                        updateXML(id, pagination.page);
                      }
                    }>Update XML</button>
                  )
                }
                syncIcon = <i className="material-icons c-yellow" title={syncIconTitle}>error_outline</i>;
              } else {
                syncIcon = '';
              }

              const lengthWarningIcon = ( lengthwarning !== true ) ? '' : <i className="material-icons c-red" title="This feed instance has items with title-length longer than the allowed threshold">report_problem</i>

              if ( disabled ) {
                syncIconTitle = "Instance is archived"
                class1 = <i className="material-icons c-yellow" title={syncIconTitle}>access_time</i>;
                class2 = ''
              } else if(active) {
                syncIconTitle = "Instance is published"
								class1 = <i className="material-icons c-light-green" title={syncIconTitle}>cloud_done</i>;
                if (xml_pending) {
                  class2 = (
                    <button className="btn waves-effect waves-light mr-10"
                            disabled="disabled">...publishing...</button>
                  );
                } else {
                  class2 = (
                    <button className="btn red darken-1 waves-effect waves-light mr-10"
                      onClick={
                        () => {
                          unpublishFeed(id, pagination.page);
                        }
                      }>Unpublish</button>
                  );
                }

                clip = (
                  <Clipboard data-clipboard-text={optimization.xml_url} className="clipboard">
                    <span>&nbsp;<span className="clip-blue">Copy url</span> |</span>
                  </Clipboard>
                );
							} else {
                syncIconTitle = "Instance is NOT published"
								class1 = <i className="material-icons c-grey" title={syncIconTitle}>cloud_upload</i>;
								class2 = (
									<button className="btn light-green waves-effect waves-light mr-10"
  									onClick={
  										() => {
  											publishFeed(id, pagination.page);
  										}
  									}>Publish</button>
								);
							}

              let links
              if ( disabled ) {
                links = ''
              } else if (optimization.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/feeds/${optimization.id}/entries`}>View</Link> |
                    {clip}
                    <Link
                      className="c-light-green"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.cloneFeed(optimization.id)
                      }}
                      >&nbsp;Clone
                    </Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(optimization.id)
                      }}
                      >&nbsp;Trash</Link>

                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.archiveFeed(optimization.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

              let link
              if ( disabled ) {
                link = <span>{name}</span>
              } else {
                link = <Link className="view" to={`/feeds/${id}/entries`}>{name}</Link>
              }
							return (
                <tr key={id}>
									<td>
										{
                      //<Link className="view" to={`/feeds/${id}/entries`}>{name}</Link>
                    }
                    { link }
                    <span className="shareable-url">{xml_url}</span>
                    { links }
									</td>
									<td>{new Date(created_at).toLocaleDateString()}, {new Date(created_at).toLocaleTimeString()}</td>
									{
                    // <td>user here</td>
                  }
                  <td>
										<small><p>{entries} Rows Published</p></small>
										<small><p>{new_entries} Rows Added</p></small>
										<small><p>{removed} Rows Deleted</p></small>
									</td>
									<td>{class1}{syncIcon}{lengthWarningIcon}</td>
                  { feedActive ? <td>{class2}{syncButton}</td> : '' }
								</tr>
							)
						}, this)}
					</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.fetchProject}/>
			</React.Fragment>
		)
	}
}

const ProjectOptimizations = connect(mapStateToProps, mapDispatchToProps)(ConnectedProjectOptimizations);

export default ProjectOptimizations;



// WEBPACK FOOTER //
// ./src/js/components/ProjectOptimizations.js